// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/js/async/" + ({"354": "lib-axios","535": "lib-router",}[chunkId] || chunkId) + "." + {"125": "764f2013","17": "cd545760","354": "1c78b830","452": "5103802e","535": "02f8acc1","635": "6ebcb563","733": "b1b8c8a6",}[chunkId] + ".js"
}